import { Button, Modal, Typography } from 'antd';

import {
  IMPACT_CALCULATION_DISCLAIMER,
  IMPACT_CALCULATION_FORMULA,
  IMPACT_CALCULATION_INTRO,
  IMPACT_CALCULATION_STEPS,
  IMPACT_CALCULATION_TITLE
} from './constants';

type CalculationModalProps = {
  open: boolean;
  onClose: () => void;
};

function CalculationModal({ open, onClose }: CalculationModalProps) {
  return (
    <Modal
      wrapProps={{ id: 'impact-meter-calculation' }}
      open={open}
      onCancel={onClose}
      title={IMPACT_CALCULATION_TITLE}
      footer={
        <Button type='primary' onClick={onClose}>
          Entendi
        </Button>
      }
    >
      <div className='flex flex-col gap-4'>
        <Typography.Text strong>{IMPACT_CALCULATION_INTRO}</Typography.Text>
        <div className='rounded-(--uizz-antd-border-radius) bg-(--uizz-antd-color-primary-bg) px-4 py-3'>
          <Typography.Text className='text-(--uizz-antd-color-primary)'>{IMPACT_CALCULATION_FORMULA}</Typography.Text>
        </div>
        <ol className='m-0 flex list-decimal flex-col gap-3 pl-5'>
          {IMPACT_CALCULATION_STEPS.map((step, index) => (
            <li key={`impact-calculation-step-${index + 1}`}>
              <Typography.Text>{step}</Typography.Text>
            </li>
          ))}
        </ol>
        <Typography.Paragraph type='secondary' className='mb-0'>
          {IMPACT_CALCULATION_DISCLAIMER}
        </Typography.Paragraph>
      </div>
    </Modal>
  );
}

export default CalculationModal;
